import Product from "../../../../../@types/Product";

const Batteries: Product[] = [
    {
        id: 1,
        name: 'ECO Lithium 105AH',
        sku: '28-479',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        name: 'ECO Lithium 60AH',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
        visible: false
    }
]

export default Batteries;